<template>
  <stats-card v-loading="loading"
              :sub-title="$t('accountsCountStatsCard.subTitle')"
              :title="total"
              type="warning"
              icon="tim-icons icon-single-02">
    <div slot="footer">
      {{$t('accountsCountStatsCard.footer')}} {{current_month}}
    </div>
  </stats-card>
</template>
<script>
  import StatsCard from 'src/components/Cards/StatsCard';
  import {mapActions, mapState} from "vuex";

  export default {
    name: 'accounts-count',
    components: {
      StatsCard,
    },
    methods: {
      ...mapActions(['LoadAccountsStats']),
    },
    computed: {
      ...mapState({
        loading: state => state.account_stats.loading,
      }),
    },
    mounted() {
      this.LoadAccountsStats();
    },
    data() {
      return {
        total: "?",
        current_month: "?",
      };
    },
    watch: {
      "$store.state.account_stats.data"(data) {
        this.total = "" + data.total;
        this.current_month = "" + data.current_month;
      }
    }
  };
</script>
